import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/PMS/baseInformation/areaGroup';
export default {
  props: ['routerIdArr', 'keyValue', 'showDialog'],
  data: function data() {
    return {
      rules: {
        upIdList: [{
          required: true,
          message: '请选择上级机构',
          trigger: 'blur'
        }],
        areaGroupName: [{
          required: true,
          message: '请输入小区分组名称',
          trigger: 'blur'
        }]
      },
      childData: {},
      options: [],
      upIdList: [],
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      }
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    loadMenuTree: function loadMenuTree() {
      var _this = this;

      var treeQuery = {
        flag: 4
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this.options = response.data.data;
      });
    },
    init: function init() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs['dataForm'].clearValidate();
      });
      this.loadMenuTree();

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this2.childData = response.data.data;
          _this2.childData.upIdList = _this2.childData.upIdList.join(',').split(','); // this.upIdList = []
          // this.childData.upIdList.forEach(e => {
          //   this.upIdList.push(e.toString())
          // })
        });
      } else {
        this.childData = {};
        this.childData.upIdList = this.routerIdArr;
      }
    },
    handCreate: function handCreate() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this3.childData.upIdList !== null & _this3.childData.upIdList.length > 0) {
            _this3.childData.upAreaId = _this3.childData.upIdList[_this3.childData.upIdList.length - 1];
            delete _this3.childData.upIdList;

            if (_this3.keyValue > 0) {
              fetchUpdate(_this3.childData).then(function () {
                _this3.$emit('handCancle', true);

                _this3.Alert({
                  alertType: 'update'
                });
              });
            } else {
              fetchCreate(_this3.childData).then(function () {
                _this3.$emit('handCancle', true);

                _this3.Alert({
                  alertType: 'add'
                });
              });
            }
          } else {
            _this3.Alert({
              alertType: 'error',
              message: '请选择上级机构！'
            });
          }
        } else {
          _this3.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};